import React from "react";

import background from '@cover/kreativitaetstarten/background-1.svg';
import background2 from '@cover/kreativitaetstarten/background-2.png';
import background2Sm from '@cover/kreativitaetstarten/background-2-sm.png';
import KreativitaetStarten from "../components/cover/animations/kreativitaetstarten";

import articleSrc from '@assets/article.svg';

export const meta = {
	category: "start",
	slug: "kreativitaet",
	id: "KreativitaetStarten",
	excerpt: {
		before: "Ida Berger hat mit einer Freundin am Ulmer Schubart-Gymnasium einen Kreativwettbewerb ins Leben gerufen. Sie wollten ihre Mitschülerinnen und Mitschüler motivieren, sich über Fotos, Videos oder mit eigenen Texten künstlerisch mit ihrem Alltag in Zeiten von Corona auseinanderzusetzen. Unterstützt wurden die Freundinnen dabei vom Programm ",
		italic: "Push Dich",
		after: "!"
	},
	name: "kreativitätstarten",
	title: "Der Geschmack von Glück",
	animation: KreativitaetStarten,
	cover: {
		background: {
			lg: background,
			sm: background
		},
		layers: [
			{
				src: {
					lg: background2,
					sm: background2Sm
				},
				zIndex: 666
			}
		],
		alt: "Ida Berger, Teilnehmerin im Programm 'Push Dich!' stützt ihren Kopf auf ihre Hände. Sie ist umgeben von verschiedenen Doodles, Formen, Skizzen und dem plastischen Schriftzug 'frei entfalten'."
	}
}

const KreativitaetstartenArticle = () => {
	return (
		<div>
			<p className="articleParagraph">
				Ich schreibe sehr viel. Ich mache bei der Schülerzeitung mit, bin im Debattierclub und finde Sprachen unglaublich toll. Mir ist aufgefallen, dass während Corona vieles stagniert. Wir haben seit einem Jahr keine Schülerzeitung mehr herausgebracht und wegen des Abistresses habe ich aufgehört zu schreiben. Ich vermisse das. 
			</p>
			<p className="articleParagraph">
				Wenn mich irgendwas beschäftigt, dann habe ich das Bedürfnis, es aufzuschreiben und irgendwie anders zu verpacken. Weil ich aber zurzeit nicht schreibe, lasse ich weniger raus und dadurch bin ich gestresster. Es fällt mir auch schwerer zu schreiben, weil ich zu verkrampft bin. Wenn man sich zu sehr auf eine Sache konzentriert, verliert man andere aus dem Blick. 
			</p>
			<p className="articleParagraph">
				Ich mache jetzt sehr viel Sport, weil es mir hilft, Gedanken wegzuschieben und einfach an nichts zu denken. Das Leben mit Corona erzeugt in mir einen Strudel aus Gedanken, der sich immer weiter dreht. Mit Sport kann ich da ausbrechen und den Kopf wieder frei kriegen. Einerseits ist es natürlich gut, wenn man sich mit der aktuellen Situation befasst. Andererseits... man muss auch unterscheiden können, mit wieviel gehts mir gut und wann wirds einfach zu viel. 
			</p>
			<p className="articleParagraph">
				Meine Generation kann sich nicht so entfalten, wie sie es möchte. Nach dem Abitur will man doch eigentlich erstmal weg und verreisen. Das wird aber nicht gehen. Wir müssen uns in einem Rahmen bewegen, der angemessen ist. 
			</p>
			<p className="articleHint">
				Ida Berger hat mit einer Freundin das KulturStarter-Projekt „CoronaKultur“ am Ulmer Schubart-Gymnasium umgesetzt. Mit einem Kreativwettbewerb haben die beiden ihre Mitschülerinnen und Mitschüler motiviert, sich auf künstlerische Weise mit ihrem Alltag auseinanderzusetzen – entweder über Fotos, Videos oder mit eigenen Texten. Die Akteurinnen wurden dabei vom Programm Push Dich! unterstützt. Wenn der Jahresbericht erschienen ist, hat Ida Berger ihr Abitur bereits bestanden. Die 18-Jährige wird dann voraussichtlich noch nicht verreisen können, dennoch hat sie einen Plan: Sie möchte an einem Kolleg ein Studium Generale absolvieren, um herauszufinden, was sie in Zukunft beruflich machen möchte.
			</p>
			<p className="articleStatement">
				« Ich denke, es ist wichtiger denn je, die eigene Kreativität
				auszuleben. Weil es das Einzige ist, was Magie und Farbe
				ins Leben bringt. Und es ist eine der wenigen Möglichkeiten,
				die man ohne Einschränkung machen darf und bei
				der man sich frei entfalten kann. Natürlich ist Kreativität
				nicht die Lösung für alles. Aber sie kann helfen, persönliche
				Hindernisse zu überwinden. »
			</p>
			<a href="https://www.push-dich-bw.de/" target="_blank" className="articleLink articleLink--block">
			 	<div className="articleLinkIcon">
					<img src={articleSrc} />
				</div>
				<div>
					PUSH DICH! und lass dein Projekt fördern
					<div className="articleLinkSource">
						push-dich-bw.de
					</div>
				</div>
			</a>
		</div>
	)
};

export default KreativitaetstartenArticle;